import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authApi, fetchCsrfCookie } from '../services/api';

export const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';

  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const linkIsInvalid = !token || !email;

  useEffect(() => {
    if (!success) return;
    const timer = setTimeout(() => navigate('/login'), 3000);
    return () => clearTimeout(timer);
  }, [success, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }
    if (password !== passwordConfirmation) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    setLoading(true);
    try {
      // C01 — Sanctum SPA : refresh du cookie XSRF-TOKEN avant tout POST mutant
      // pour le cas où l'utilisateur arrive directement sur /reset-password
      // depuis le lien reçu par email.
      await fetchCsrfCookie();
      await authApi.resetPassword({ token, email, password, password_confirmation: passwordConfirmation });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Impossible de réinitialiser le mot de passe. Le lien a peut-être expiré.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Réinitialiser le mot de passe</h1>

        {linkIsInvalid && !success && (
          <div className="auth-error">
            Ce lien de réinitialisation est invalide. Veuillez refaire une demande.
          </div>
        )}

        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}

        {success && (
          <div className="auth-success">
            Votre mot de passe a été réinitialisé avec succès. Vous allez être redirigé vers la connexion...
          </div>
        )}

        {!linkIsInvalid && !success && (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="password">Nouveau mot de passe</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Minimum 8 caractères"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password_confirmation">Confirmer le mot de passe</label>
              <input
                id="password_confirmation"
                type="password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                placeholder="Confirmez votre mot de passe"
                disabled={loading}
              />
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
            </button>
          </form>
        )}

        <div className="auth-links">
          <a href="/login">Retour à la connexion</a>
        </div>
      </div>
    </div>
  );
};
